import Vue from "vue";

/**
 * Class Profile Service
 */
export default class ConquestService extends Vue {
    
    private customActions = {
        indexConquest: { method: 'GET', url: 'auth/index-conquest/{type_conquest}/{id_platform}/{id_user}' },
        indexHistoryConquest: { method: 'GET', url: 'auth/index-history-conquest/{id_conquest}/{id_platform}/{id_user}' },
    };
    
    private resource: any = this.$resource('auth/index-conquest/', {}, this.customActions);

    public async indexConquest(type_conquest: string, id_user: number, id_platform: number) {
        return await this.resource.indexConquest({ type_conquest, id_platform, id_user }).then(
            (response: any) => {
                return response.json();
            },
            (response: any) => {
                return response.json();
            }
        );
    }

    public async indexHistoryConquest(id_conquest: string, id_user: number, id_platform: number) {
        return await this.resource.indexHistoryConquest({ id_conquest, id_platform, id_user }).then(
            (response: any) => {
                return response.json();
            },
            (response: any) => {
                return response.json();
            }
        );
    }
}